import React from 'react';
import SiteNav from '../components/SiteNav';
import Hero from '../components/Hero';
import AuthorizationInAction from '../components/AuthorizationInAction';
import WhatQSSNProtects from '../components/WhatQSSNProtects';
import LiveMonitoring from '../components/ControlPlanePreview';
import ExploreQSSN from '../components/ExploreQSSN';
import Footer from '../components/Footer';

const Home: React.FC = () => (
  <>
    <SiteNav />
    <Hero />
    <AuthorizationInAction />
    <WhatQSSNProtects />
    <LiveMonitoring />
    <ExploreQSSN />
    <Footer />
  </>
);

export default Home;
